import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ProductCategory, GmpProductDetail, ManufacturingOperation, OffsiteFacility, OffsiteFacilityTypes, ProductionLine, SpecificManufacturingOperation } from '../../../inspection/shared/models/Inspection';
import { ErisFormFieldType } from 'eris-forms';
import { Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { environment } from '../../../../environments/environment';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ErisFormModalComponent } from '../eris-form-modal/eris-form-modal.component';
import { InspectionService } from '../../../inspection/shared/services/inspection.service';

@Component({
  selector: 'app-gmp-product-detail',
  templateUrl: './gmp-product-detail.component.html',
  styleUrls: ['./gmp-product-detail.component.css']
})
export class GmpProductDetailComponent extends ErisFormFieldType implements OnInit {

  public totalProdDetails: GmpProductDetail[] = [];
  public selectedProductCategory : ProductCategory;
  public selectedManuOp: ManufacturingOperation;
  public selectedProdLine: ProductionLine;
  public selectedSpecificManuOp: SpecificManufacturingOperation;
  public offsiteFacilityTypes: any = OffsiteFacilityTypes;
  public expandedProdDetailIds: number[] = [];
  public totalOffsiteFacilities: OffsiteFacility[] = [];

  public isDisabled: boolean = false;
  public editing : boolean = false;
  public isDataFilled : boolean = false;
  public modalRef: BsModalRef;

  public offsitePackagingRequiredError: boolean = false;
  public offsiteQualityControlTestRequiredError: boolean = false;
  public offsiteBatchCertificationRequiredError: boolean = false; 


  constructor(private cdr: ChangeDetectorRef, private modalService: BsModalService, private inspectionService: InspectionService) {
      super();
     }

  ngOnInit(): void {
    // we will ran it after a timeout to wait for angular to set templateOptions.editing
    setTimeout(() => {
      this.editing = this.field.templateOptions.editing;
      this.isDataFilled = this.field.templateOptions.isDataFilled;
      this.isDisabled = this.field.templateOptions.isDisabled;
      if(this.editing || this.isDataFilled){
        this.field.formControl.valueChanges.pipe(first(val => val != null)).subscribe((val) => {
          this.totalProdDetails = val ? val.productDetails : [];
          if(this.totalProdDetails.length > 0) {
            const { totalOffsiteFacilities } = this.inspectionService.getOffsiteFacilitiesInfo(this.totalProdDetails);
            this.totalOffsiteFacilities = totalOffsiteFacilities;
          }
        });
      }
      // this.field.formControl isn't tied to any form input element, so we set the validator manually
      if(!this.field.templateOptions.dependsOnField){
        this.field.formControl.setValidators([Validators.required]);
        this.field.formControl.updateValueAndValidity();
      } else {
        this.form.parent.get(this.field.templateOptions.dependsOnField)?.valueChanges.subscribe(() => {
          let cat = this.form.parent.get(this.field.templateOptions.dependsOnField).value;
          if(cat["name"] == "Category A"){
            this.field.formControl.clearValidators();
            this.totalProdDetails = [];
            this.field.formControl.setValue(null);
          }else {
            this.field.formControl.setValidators([Validators.required]);
          }
          this.field.formControl.updateValueAndValidity();
          this.cdr.detectChanges();
        })
      }
      
      this.cdr.detectChanges();
    }, 500)
  }

  addNewProdDetailClicked() {
    const initialState = {
      title: 'Add Product Detail',
      fields: this.fields
    };

    this.modalRef = this.modalService.show(ErisFormModalComponent, {initialState, class: 'modal-lg'});
    this.modalRef.content.closeModal.subscribe(() => {
      this.modalRef.hide();
      this.cleanUpForm();
    });
    this.modalRef.content.submitForm.subscribe((data: any) => {
      this.saveClicked(data);
    });
  }

  deleteProdDetail(productionLineId: number) {
    this.totalOffsiteFacilities.forEach((offsiteFacility) => {
      // Remove the production line with the specified ID
      offsiteFacility.productionLines = offsiteFacility.productionLines ? offsiteFacility.productionLines.filter(
        (productionLine) => productionLine.id !== productionLineId) : [];
    });
    this.totalOffsiteFacilities = this.totalOffsiteFacilities.filter(t => t.productionLines.length > 0);

    this.totalProdDetails = this.totalProdDetails.filter(p => p.productionLine.id != productionLineId);
    if(this.totalProdDetails.length == 0){
      this.field.formControl.setValue(null);
    } else {
      this.field.formControl.setValue({"productDetails": this.totalProdDetails});
    }
    this.cdr.detectChanges();
  }

  saveClicked(formData) {
    // validation
    this.offsitePackagingRequiredError = !formData.offsitePackagingCheckbox && !formData.packaging;
    this.offsiteQualityControlTestRequiredError = !formData.offsiteQualityControlTestCheckbox && !formData.qualityControlTests;
    this.offsiteBatchCertificationRequiredError = !formData.offsiteBatchCertificationCheckbox && !formData.batchCertification;

    if(this.offsitePackagingRequiredError || this.offsiteQualityControlTestRequiredError || this.offsiteBatchCertificationRequiredError) {
      return;
    }
  let index = this.totalProdDetails.findIndex(pd =>
  pd.productionLine.id == formData.productionLine?.id &&
  pd.packaging?.id == formData.packaging?.id
);
    if(index != - 1) {
      // remove the older product detail if they add a duplicate production line
      this.totalProdDetails.splice(index, 1);
    }

    let productDetail = new GmpProductDetail(formData);
    if(formData.offsitePackagingCheckbox) {
      let offsitePackagingFacility = null;
      if(formData.offsitePackagingPreviousSelect && formData.offsitePackagingPreviousSelect.value != 0) {
        offsitePackagingFacility = this.totalOffsiteFacilities.find(a => a.identifier == formData.offsitePackagingPreviousSelect.value);
      } else {
        offsitePackagingFacility = new OffsiteFacility(formData.offsitePackagingFacility, OffsiteFacilityTypes.PACKAGING);
        offsitePackagingFacility.identifier = this.totalOffsiteFacilities.length + 1;
        this.totalOffsiteFacilities.push(offsitePackagingFacility);  
      }

      productDetail.offsiteFacilities.push(offsitePackagingFacility);
      offsitePackagingFacility.productionLines.push(productDetail.productionLine);
    }

    if(formData.offsiteQualityControlTestCheckbox) {
        let offsiteQCTFacility = null;
        if(formData.offsiteQualityControlTestPreviousSelect && formData.offsiteQualityControlTestPreviousSelect.value != 0) {
          offsiteQCTFacility = this.totalOffsiteFacilities.find(a => a.identifier == formData.offsiteQualityControlTestPreviousSelect.value);
        } else {
          offsiteQCTFacility = new OffsiteFacility(formData.offsiteQualityControlTestFacility, OffsiteFacilityTypes.QUALITY_CONTROL_TESTING);
          offsiteQCTFacility.identifier = this.totalOffsiteFacilities.length + 1;
          this.totalOffsiteFacilities.push(offsiteQCTFacility);
        }

        productDetail.offsiteFacilities.push(offsiteQCTFacility);
        offsiteQCTFacility.productionLines.push(productDetail.productionLine); 
    }

    if(formData.offsiteBatchCertificationCheckbox) {
        let offsiteBCFacility  = null;
        if(formData.offsiteBatchCertificationPreviousSelect && formData.offsiteBatchCertificationPreviousSelect.value != 0) {
          offsiteBCFacility = this.totalOffsiteFacilities.find(a => a.identifier == formData.offsiteBatchCertificationPreviousSelect.value);       
        } else {
          offsiteBCFacility = new OffsiteFacility(formData.offsiteBatchCertificationFacility, OffsiteFacilityTypes.BATCH_CERTIFICATION);
          offsiteBCFacility.identifier = this.totalOffsiteFacilities.length + 1;
          this.totalOffsiteFacilities.push(offsiteBCFacility);
        }

        productDetail.offsiteFacilities.push(offsiteBCFacility);
        offsiteBCFacility.productionLines.push(productDetail.productionLine);
    }

    this.totalProdDetails.push(productDetail);
    this.field.formControl.setValue({"productDetails": this.totalProdDetails});
    this.cdr.detectChanges();
    this.modalRef.hide();
    this.cleanUpForm();
  }

  joinLookupTypes(array: any[]) {
    if(!array || array.length == 0) {
      return "-";
    }
    return array.map(q => q.name).join(" , ");
  }

  isExpanded(prodDetailId: number) {
    const index = this.expandedProdDetailIds.findIndex(id => id === prodDetailId);
    return index !== -1;
  }

  expandOffsiteInfo(prodDetailId: number) {
    const index = this.expandedProdDetailIds.findIndex(id => id === prodDetailId);
    if (index !== -1) {
      return;
    }

    this.expandedProdDetailIds.push(prodDetailId);
  }

  collapseOffsiteInfo(prodDetailId: number) {
    const index = this.expandedProdDetailIds.findIndex(id => id === prodDetailId);

    if (index !== -1) {
      this.expandedProdDetailIds.splice(index, 1);
    }
  }

  deleteOffsiteFacility(identifier) {
    this.totalProdDetails.forEach((prodDetail) => {
      prodDetail.offsiteFacilities = prodDetail.offsiteFacilities ? prodDetail.offsiteFacilities.filter(f => f.identifier !== identifier): [];
    })
    this.totalOffsiteFacilities = this.totalOffsiteFacilities.filter(f => f.identifier !== identifier);
  }
  
  private cleanUpForm(){
    this.selectedProductCategory = null;
    this.selectedManuOp = null;
    this.selectedProdLine = null;
    this.selectedSpecificManuOp = null;
  }

  fields =[
    {
      fieldGroup: [
        {
          fieldGroupClassName: "row",
          fieldGroup : [
            {
              key: 'productCategory',
              type: 'lookup',
              className: "col-md-6",
              templateOptions: {
                label: 'Product Category',
                required: true,
                multiple: false,
                prefetch: true,
                searchable: false,
                minLengthTerm: 0,
                responseFn: (res) => {
                  this.selectedProductCategory = res;
                  return ({
                    name: res.name,
                    id: res.id,
                  })
                },
                list: {
                  method: "get",
                  url: (term) =>
                    `${environment.baseUrl}/ProductCategory`,
                  responseFn: (res) => res,
                },
              },
            },
            {
              key: 'manufacturingOperation',
              type: 'lookup',
              className: "col-md-6",
              templateOptions: {
                label: 'Manufacturing Operation',
                required: true,
                multiple: false,
                prefetch: true,
                searchable: false,
                minLengthTerm: 0,
                dependsOnField: "productCategory",
                responseFn: (res: ManufacturingOperation) => {
                  this.selectedManuOp = res;
                  if(this.selectedManuOp.specificManufacturingOperations.length == 1) {
                    this.selectedSpecificManuOp = this.selectedManuOp.specificManufacturingOperations[0];
                  }
                  return res;
                },
                list: {
                  method: "get",
                  url: (term) =>
                    `${environment.baseUrl}/ProductCategory/GetManufacturingOperations/${this.selectedProductCategory?.id}`,
                  responseFn: (res) => res,
                },
              },
            },
            {
              key: 'specificManufacturingOperation',
              type: 'lookup',
              className: "col-md-6",
              templateOptions: {
                label: 'Specific Manufacturing Operation',
                required: true,
                multiple: false,
                prefetch: true,
                searchable: false,
                minLengthTerm: 0,
                dependsOnField: "manufacturingOperation",
                responseFn: (res) => {
                  this.selectedSpecificManuOp = res;
                  return res;
                },
                list: {
                  method: "get",
                  url: (term) =>
                    `${environment.baseUrl}/ProductCategory/GetSpecificManufacturingOperations/${this.selectedManuOp?.id}`,
                  responseFn: (res) => res,
                },
              },
              hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                let mo : ManufacturingOperation = field.form.get("manufacturingOperation")?.value;
                if (mo && mo.specificManufacturingOperations && mo.specificManufacturingOperations.length > 1) {
                  return false;
                }
                return true;
              },
            },
            {
              key: 'productionLine',
              type: 'lookup',
              className: "col-md-6",
              templateOptions: {
                label: 'Production Line',
                required: true,
                multiple: false,
                prefetch: true,
                searchable: false,
                minLengthTerm: 0,
                dependsOnField: "specificManufacturingOperation",
                responseFn: (res) => {
                  this.selectedProdLine = res;
                  return res;
                },
                list: {
                  method: "get",
                  url: (term) =>
                    `${environment.baseUrl}/ProductCategory/GetProductionLines/${this.selectedSpecificManuOp?.id}`,
                  responseFn: (res) => res,
                },
              },
            },
          ]
        },
        {
          fieldGroupClassName: "row",
          fieldGroup : [
            {
              key: 'packagingTypes',
              type: 'lookup',
              className: "col-md-6",
              templateOptions: {
                label: 'Packaging Type',
                required: true,
                multiple: true,
                prefetch: true,
                searchable: false,
                minLengthTerm: 0,
                responseFn: (res) => {
                  return res;
                },
                list: {
                  method: "get",
                  url: (term) =>
                    `${environment.baseUrl}/ProductCategory/GetPackagingTypes`,
                  responseFn: (res) => res,
                },
              },
                expressionProperties: {
                      'templateOptions.required': (model: any, formState: any) => {
                        const mo: any = model.manufacturingOperation; 
                        return mo?.name?.toLowerCase() !== '1.1 non-sterile medicinal products';
                      },
                    }
            },
            {
              key: 'packaging',
              type: 'lookup',
              className: "col-md-6",
              templateOptions: {
                label: 'Packaging',
                required: true,
                multiple: false,
                prefetch: true,
                searchable: false,
                minLengthTerm: 0,
                dependsOnField: "manufacturingOperation",
                responseFn: (res) => {
                  return res;
                },
                list: {
                  method: "get",
                  url: (term) =>
                    `${environment.baseUrl}/ProductCategory/GetPackagings/${this.selectedManuOp?.name}`,
                  responseFn: (res) => res,
                },
              },
              hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                var packagingTypes = field.form.get("packagingTypes")?.value;
                if ((this.selectedManuOp?.name == "1.2 Sterile Products") || (packagingTypes != null && packagingTypes.length > 0 
                  && packagingTypes.findIndex(p => p.name == 'Primary') != -1)) {
                  return false;
                }
                return true;
              },
            },
          ]
        },
        {
          fieldGroupClassName: "row",
          fieldGroup : [
            {
              key: 'qualityControlTests',
              type: 'lookup',
              className: "col-md-6",
              templateOptions: {
                label: 'Quality Control Tests',
                required: true,
                multiple: true,
                prefetch: true,
                searchable: false,
                minLengthTerm: 0,
                responseFn: (res) => {
                  return res;
                },
                list: {
                  method: "get",
                  url: (term) =>
                    `${environment.baseUrl}/QualityControlTest`,
                  responseFn: (res) => res,
                },
              },
              expressionProperties: {
                "templateOptions.required": (model, formState, field: FormlyFieldConfig) => {
                  var manufacturingOperation = field.form.get("manufacturingOperation")?.value;
                  if (manufacturingOperation != null && manufacturingOperation.name == "1.1 Non-Sterile Medicinal Products") {
                    return false;
                  }
                  return true;
                },
              }
            },
            {
              key: 'batchCertification',
              type: 'checkbox',
              className: "col-md-6",
              templateOptions: {
                label: 'Batch Certification',
                required: true
              },
            },
          ]
        },
        {
          fieldGroupClassName: "row",
          fieldGroup : [
            {
              key: 'offsitePackagingCheckbox',
              type: 'checkbox',
              className: "col-md-6",
              templateOptions: {
                label: 'Offsite Packaging',
                required: true
              },
            },
            {
              template:
              "<span class='text-danger'>Offsite Packaging Needs to be filled if there is no on-site Packaging</span>",       
              hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                let offsitePackagingCheckbox = field.form.get("offsitePackagingCheckbox")?.value;
                let onsitePackaging = field.form.get("packaging")?.value;
                let showError = this.offsitePackagingRequiredError && !offsitePackagingCheckbox && !onsitePackaging;
                return !showError;
              },
            },
            {
              key: 'offsitePackagingPreviousSelect',
              type: 'select',
              className: "col-md-6",
              templateOptions: {
                label: 'Offsite Packaging Facility',
                required: true,
                items: [
                  {title: "Add New", value: 0}
                ]
              },
              hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                var offsitePackagingCheckbox = field.form.get("offsitePackagingCheckbox")?.value;
                if (offsitePackagingCheckbox == null || offsitePackagingCheckbox == false) {
                  return true;
                }
                return this.totalOffsiteFacilities.filter(t => t.facilityType == OffsiteFacilityTypes.PACKAGING).length == 0;
              },
              expressionProperties: {
                "templateOptions.items": (model, formState, field: FormlyFieldConfig) => {
                  var lookup = this.totalOffsiteFacilities.filter(t => t.facilityType == OffsiteFacilityTypes.PACKAGING)
                          .map(t => ({title: `${t.name}-${t.address}-${t.streetNumber}`, value: t.identifier}));
                  lookup.push({title: "Add New", value: 0});
                  return lookup;
                },
              }
            }
          ]
        },
        {
          fieldGroupClassName: "row",
          key: "offsitePackagingFacility",
          fieldGroup : [
            {
              key: "name",
              type: "input",
              className: "col-md-6",
              templateOptions: {
                label: "Facility Name",
                required: true
              },
              validators: {
                validation: ["normal-text"],
              },
            },
            {
              key: "address",
              type: "input",
              className: "col-md-6",
              templateOptions: {
                label: "Address",
                required: true
              },
              validators: {
                validation: ["normal-text"],
              },
            },
            {
              key: "streetNumber",
              type: "input",
              className: "col-md-6",
              templateOptions: {
                label: "Street Number",
                required: true
              },
              validators: {
                validation: ["normal-text"],
              },
            },
            {
              key: "phone",
              type: "international-phone",
              className: "col-md-6",
              templateOptions: {
                label: "Phone",
                required: true
              },
            },
            {
              key: "email",
              type: "input",
              className: "col-md-6",
              templateOptions: {
                label: "Email",
                type: "email",
                required: true
              },
              validators: {
                validation: ["email"],
              },
            },
            {
              key: "website",
              type: "input",
              className: "col-md-6",
              templateOptions: {
                label: "Website",
                required: true
              },
              validators: {
                validation: ["normal-text"],
              },
            },
            {
              key: 'offsitePackagingTypes',
              type: 'lookup',
              className: "col-md-6",
              templateOptions: {
                label: 'Packaging Type',
                required: true,
                multiple: true,
                prefetch: true,
                searchable: false,
                minLengthTerm: 0,
                responseFn: (res) => {
                  return res;
                },
                list: {
                  method: "get",
                  url: (term) =>
                    `${environment.baseUrl}/ProductCategory/GetPackagingTypes`,
                  responseFn: (res) => res,
                },
              },
            },
            {
              key: 'offsitePackaging',
              type: 'lookup',
              className: "col-md-6",
              templateOptions: {
                label: 'Packaging',
                required: true,
                multiple: false,
                prefetch: true,
                searchable: false,
                minLengthTerm: 0,
                dependsOnField: "manufacturingOperation",
                responseFn: (res) => {
                  return res;
                },
                list: {
                  method: "get",
                  url: (term) =>
                    `${environment.baseUrl}/ProductCategory/GetPackagings/${this.selectedManuOp?.name}`,
                  responseFn: (res) => res,
                },
              },
              hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                var packagingTypes = field.form.get("offsitePackagingTypes")?.value;
                if (packagingTypes != null && packagingTypes.length > 0 && packagingTypes.findIndex(p => p.name == 'Primary') != -1) {
                  return false;
                }
                return true;
              },
            },
          ],
          hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
            var offsitePackagingCheckbox = field.form.get("offsitePackagingCheckbox")?.value;
            if (offsitePackagingCheckbox == null || offsitePackagingCheckbox == false) {
              return true;
            }

            var offsitePackagingPreviousSelect = field.form.get("offsitePackagingPreviousSelect")?.value?.value;
            return this.totalOffsiteFacilities.filter(t => t.facilityType == OffsiteFacilityTypes.PACKAGING).length > 0 
                && offsitePackagingPreviousSelect > 0;
          },
        },
        {
          fieldGroupClassName: "row",
          fieldGroup : [
            {
              key: 'offsiteQualityControlTestCheckbox',
              type: 'checkbox',
              className: "col-md-6",
              templateOptions: {
                label: 'Offsite Quality Control Test',
                required: true
              },
            },
            {
              template:
              "<span class='text-danger'>Offsite Quality Control Test Needs to be filled if there is no on-site Quality Control Test</span>",       
              hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                let offsiteQualityControlTestCheckbox = field.form.get("offsiteQualityControlTestCheckbox")?.value;
                let onsiteQualityControlTest = field.form.get("qualityControlTests")?.value;
                let showError = this.offsiteQualityControlTestRequiredError && !offsiteQualityControlTestCheckbox && !onsiteQualityControlTest;
                return !showError;
              },
            },
            {
              key: 'offsiteQualityControlTestPreviousSelect',
              type: 'select',
              className: "col-md-6",
              templateOptions: {
                label: 'Offsite Quality Control Test Facility',
                required: true,
                items: [
                  {title: "Add New", value: 0}
                ]
              },
              hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                var offsiteQualityControlTestCheckbox = field.form.get("offsiteQualityControlTestCheckbox")?.value;
                if (offsiteQualityControlTestCheckbox == null || offsiteQualityControlTestCheckbox == false) {
                  return true;
                }
                return this.totalOffsiteFacilities.filter(t => t.facilityType == OffsiteFacilityTypes.QUALITY_CONTROL_TESTING).length == 0;
              },
              expressionProperties: {
                "templateOptions.items": (model, formState, field: FormlyFieldConfig) => {
                  var lookup = this.totalOffsiteFacilities.filter(t => t.facilityType == OffsiteFacilityTypes.QUALITY_CONTROL_TESTING)
                          .map(t => ({title: `${t.name}-${t.address}-${t.streetNumber}`, value: t.identifier}));
                  lookup.push({title: "Add New", value: 0});
                  return lookup;
                },
              }
            }
          ]
        },
        {
          fieldGroupClassName: "row",
          key: "offsiteQualityControlTestFacility",
          fieldGroup : [
            {
              key: "name",
              type: "input",
              className: "col-md-6",
              templateOptions: {
                label: "Facility Name",
                required: true
              },
              validators: {
                validation: ["normal-text"],
              },
            },
            {
              key: "address",
              type: "input",
              className: "col-md-6",
              templateOptions: {
                label: "Address",
                required: true
              },
              validators: {
                validation: ["normal-text"],
              },
            },
            {
              key: "streetNumber",
              type: "input",
              className: "col-md-6",
              templateOptions: {
                label: "Street Number",
                required: true
              },
              validators: {
                validation: ["normal-text"],
              },
            },
            {
              key: "phone",
              type: "international-phone",
              className: "col-md-6",
              templateOptions: {
                label: "Phone",
                required: true
              },
            },
            {
              key: "email",
              type: "input",
              className: "col-md-6",
              templateOptions: {
                label: "Email",
                type: "email",
                required: true
              },
              validators: {
                validation: ["email"],
              },
            },
            {
              key: "website",
              type: "input",
              className: "col-md-6",
              templateOptions: {
                label: "Website",
                required: true
              },
              validators: {
                validation: ["normal-text"],
              },
            },
            {
              key: 'offsiteQualityControlTests',
              type: 'lookup',
              className: "col-md-6",
              templateOptions: {
                label: 'Quality Control Tests',
                required: true,
                multiple: true,
                prefetch: true,
                searchable: false,
                minLengthTerm: 0,
                responseFn: (res) => {
                  return res;
                },
                list: {
                  method: "get",
                  url: (term) =>
                    `${environment.baseUrl}/QualityControlTest`,
                  responseFn: (res) => res,
                },
              },
            },
          ],
          hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
            var offsiteQualityControlTestCheckbox = field.form.get("offsiteQualityControlTestCheckbox")?.value;
            if (offsiteQualityControlTestCheckbox == null || offsiteQualityControlTestCheckbox == false) {
              return true;
            }

            var offsiteQualityControlTestPreviousSelect = field.form.get("offsiteQualityControlTestPreviousSelect")?.value?.value;
            return this.totalOffsiteFacilities.filter(t => t.facilityType == OffsiteFacilityTypes.QUALITY_CONTROL_TESTING).length > 0 
              && offsiteQualityControlTestPreviousSelect > 0;
          },
        },
        {
          fieldGroupClassName: "row",
          fieldGroup : [
            {
              key: 'offsiteBatchCertificationCheckbox',
              type: 'checkbox',
              className: "col-md-6",
              templateOptions: {
                label: 'Offsite Batch Certification',
                required: true
              },
            },
            {
              template:
              "<span class='text-danger'>Offsite Batch Certification to be filled if there is no on-site Batch Certification</span>",       
              hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                let offsiteBatchCertificationCheckbox = field.form.get("offsiteBatchCertificationCheckbox")?.value;
                let onsiteBatchCertification = field.form.get("batchCertification")?.value;
                let showError = this.offsiteBatchCertificationRequiredError && !offsiteBatchCertificationCheckbox && !onsiteBatchCertification;
                return !showError;
              },
            },
            {
              key: 'offsiteBatchCertificationPreviousSelect',
              type: 'select',
              className: "col-md-6",
              templateOptions: {
                label: 'Offsite Batch Certification Facility',
                required: true,
                items: [
                  {title: "Add New", value: 0}
                ]
              },
              hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                var offsiteBatchCertificationCheckbox = field.form.get("offsiteBatchCertificationCheckbox")?.value;
                if (offsiteBatchCertificationCheckbox == null || offsiteBatchCertificationCheckbox == false) {
                  return true;
                }
                return this.totalOffsiteFacilities.filter(t => t.facilityType == OffsiteFacilityTypes.BATCH_CERTIFICATION).length == 0;
              },
              expressionProperties: {
                "templateOptions.items": (model, formState, field: FormlyFieldConfig) => {
                  var lookup = this.totalOffsiteFacilities.filter(t => t.facilityType == OffsiteFacilityTypes.BATCH_CERTIFICATION)
                          .map(t => ({title: `${t.name}-${t.address}-${t.streetNumber}`, value: t.identifier}));
                  lookup.push({title: "Add New", value: 0});
                  return lookup;
                },
              }
            }
          ]
        },
        {
          fieldGroupClassName: "row",
          key: "offsiteBatchCertificationFacility",
          fieldGroup : [
            {
              key: "name",
              type: "input",
              className: "col-md-6",
              templateOptions: {
                label: "Facility Name",
                required: true
              },
              validators: {
                validation: ["normal-text"],
              },
            },
            {
              key: "address",
              type: "input",
              className: "col-md-6",
              templateOptions: {
                label: "Address",
                required: true
              },
              validators: {
                validation: ["normal-text"],
              },
            },
            {
              key: "streetNumber",
              type: "input",
              className: "col-md-6",
              templateOptions: {
                label: "Street Number",
                required: true
              },
              validators: {
                validation: ["normal-text"],
              },
            },
            {
              key: "phone",
              type: "international-phone",
              className: "col-md-6",
              templateOptions: {
                label: "Phone",
                required: true
              },
            },
            {
              key: "email",
              type: "input",
              className: "col-md-6",
              templateOptions: {
                label: "Email",
                type: "email",
                required: true
              },
              validators: {
                validation: ["email"],
              },
            },
            {
              key: "website",
              type: "input",
              className: "col-md-6",
              templateOptions: {
                label: "Website",
                required: true
              },
              validators: {
                validation: ["normal-text"],
              },
            },
          ],
          hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
            var offsiteBatchCertificationCheckbox = field.form.get("offsiteBatchCertificationCheckbox")?.value;
            if (offsiteBatchCertificationCheckbox == null || offsiteBatchCertificationCheckbox == false) {
              return true;
            }

            var offsiteBatchCertificationPreviousSelect = field.form.get("offsiteBatchCertificationPreviousSelect")?.value?.value;
            return this.totalOffsiteFacilities.filter(t => t.facilityType == OffsiteFacilityTypes.BATCH_CERTIFICATION).length > 0 
                && offsiteBatchCertificationPreviousSelect > 0;
          },
        },
        {
          fieldGroupClassName: "row",
          fieldGroup : [
            {
              type: "submit",
              className: "col-md-offset-11 col-md-1",
              templateOptions: {
                label: "Save",
              },
            },
          ]
        },
      ],
    },
  ];
}
